import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiStickyDrawerFooter]',
    standalone: false
})
export class StickyDrawerFooterDirective {
  @HostBinding('class') hostClasses = 'lui-sticky-drawer-footer';
}
